module.exports = __webpack_public_path__ + "static/img/solution_png1.de069c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution_png1.jpg
// module id = gKXW
// module chunks = 1